import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const baseStyle = defineStyle({
  borderStyle: "solid",
  color: "white",
  padding: 0,
});

const activeStyle = defineStyle(({ colorScheme }) => ({
  backgroundColor: `${colorScheme}.300`,
  _hover: {
    backgroundColor: `${colorScheme}.200`,
  },
  _active: {
    backgroundColor: `${colorScheme}.600`,
  },
}));

const glassStyle = defineStyle(({ colorScheme }) => ({
  backdropFilter: "auto",
  backdropBlur: "2px",
  backgroundColor: "transparent",
  bgGradient: "radial(circle, darkBlue.600, gray.50)",
  borderColor: colorScheme === "gray" ? "white" : `${colorScheme}.400`,
  borderStyle: "solid",
  borderWidth: "1px",
  padding: "15px",
}));

const inactiveStyle = defineStyle(({ colorScheme }) => ({
  backgroundColor: `${colorScheme}.700`,
  _hover: {
    backgroundColor: `${colorScheme}.800`,
  },
  _active: {
    backgroundColor: `${colorScheme}.500`,
  },
}));

const magicStyle = defineStyle({
  bgGradient: "linear(135deg, #BFBFBF99, #BFBFBF33)",
  backgroundColor: "transparent",
  borderColor: "#FFFFFF55",
  boxShadow: `0px 10px 25px #00000033`,
  borderStyle: "solid",
  borderWidth: "1px",
  height: "90px",
  width: "80px",
  wordBreak: "break-word",
  fontWeight: "none",
  _hover: {
    backgroundColor: "#FDD85D33",
    borderColor: "#FDD85D33",
    color: "#FDD85D",
  },
  _active: {
    backgroundColor: "#FDD85D99",
    borderColor: "#FDD85D99",
    color: "#FDD85D",
  },
});

const navigationStyle = defineStyle(({ colorScheme }) => ({
  bgGradient: "linear(135deg, #BFBFBF99, #BFBFBF33)",
  backgroundColor: colorScheme === "gray" ? "transparent" : `${colorScheme}.300`,
  boxShadow: `0px 10px 25px #00000033`,
  borderColor: "#FFFFFF55",
  borderStyle: "solid",
  borderWidth: "1px",
  height: "90px",
  width: "80px",
  wordBreak: "break-word",
  fontWeight: "none",
  _hover: {
    backgroundColor: `${colorScheme}.300`,
    borderColor: colorScheme === "gray" ? "white" : `${colorScheme}.900`,
  },
  _active: {
    backgroundColor: `${colorScheme}.400`,
    borderColor: colorScheme === "gray" ? "white" : `${colorScheme}.900`,
  },
}));

const buttonTheme = defineStyleConfig({
  baseStyle,
  variants: {
    active: activeStyle,
    glass: glassStyle,
    inactive: inactiveStyle,
    magic: magicStyle,
    navigation: navigationStyle,
  },
});

export default buttonTheme;
